import { memo } from "react";
import { Box, Container, Grid2, Stack, SxProps } from "@mui/material";
import { useOnMobile } from "@core/hooks/useOnMobile";
import { useDrawerSlice } from "@/app/store/slices/drawer";
import NotificationStack from "@core/components/NotificationStack";

import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Routes from "@/app/routing/Routes";
import SubscriptionBanner from "@ui/SubscriptionBanner";
import { NotificationDrawer } from "../../../ui-kit/NotificationDrawer";

export const navbarHeight = "80px";
export const footerHeight = "54px";
export const availableViewportHeight = `calc(100vh - ${navbarHeight} - ${footerHeight})`;

const AppLayout = memo(() => {
    const onMobile = useOnMobile();
    const { isOpen } = useDrawerSlice();

    const containerStyles: SxProps = {
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
    };

    const contentStyles: SxProps = {
        flex: 1,
        display: "flex",
        overflow: "hidden",
        overflowX: "hidden",
    };

    return (
        <Box sx={containerStyles}>
            <Box sx={contentStyles}>
                <Grid2 container spacing={0} sx={{ flex: 1, overflowX: "hidden" }}>
                    <Container maxWidth={"xl"}>
                        <Navbar />

                        {/* Globaler Abonnement-Banner (wird nur angezeigt, wenn nötig) */}
                        <SubscriptionBanner />

                        {/* Scrollable content area */}
                        <Box
                            px={1.5}
                            sx={{ overflowY: "auto", maxHeight: availableViewportHeight }}
                        >
                            <Routes />
                        </Box>
                    </Container>
                </Grid2>
            </Box>

            {/* Footer anzeigen, wenn nicht auf Mobilgeräten und Drawer geschlossen ist */}
            {!onMobile && !isOpen && (
                <Box maxHeight={footerHeight}>
                    <Container maxWidth={"xl"}>
                        <Footer />
                    </Container>
                </Box>
            )}

            {/* Notification Stack */}
            <NotificationStack />
            
            {/* Notification Drawer */}
            <NotificationDrawer />
        </Box>
    );
});

export default AppLayout;
